import { render, staticRenderFns } from "./WhyHomePage.vue?vue&type=template&id=7a8247b4&scoped=true"
import script from "./WhyHomePage.vue?vue&type=script&lang=js"
export * from "./WhyHomePage.vue?vue&type=script&lang=js"
import style0 from "./WhyHomePage.vue?vue&type=style&index=0&id=7a8247b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a8247b4",
  null
  
)

export default component.exports